import { createFileRoute } from '@tanstack/react-router';
import { AttendanceSourcesPage } from '@/features/attendance/AttendanceSourcesPage';

/**
 * Sorgenti di validazione della timbratura — `erp-attendance-sources` (BE CLOCK-IN-v2 §1.2,
 * revoca in v1.109 §W1). Richiede `attendance.source.write` per programmare e revocare.
 */
export const Route = createFileRoute('/_app/admin/attendance-sources')({ component: AttendanceSourcesPage });
